<template>
  <info-header-card
    :icon="instrument_instance.icon()"
    :header="header"
    :rows="rows"
  />
</template>
<script>
import InfoHeaderCard from "@/components/shared/InfoHeaderCard";
import InstrumentInstanceModel from "@/models/lab/InstrumentInstanceModel";

export default {
  name: "InstrumentInstanceCard",
  components: {
    InfoHeaderCard
  },
  props: {
    instrument_instance: {
      type: Object,
      default: () => new InstrumentInstanceModel()
    }
  },
  computed: {
    header() {
      return this.instrument_instance.name;
    },
    rows() {
      return [
        {
          label: "Instrument",
          value: this.instrument_instance.instrument
            ? this.instrument_instance.instrument.name
            : this.instrument_instance.instrument_id
              ? "Deleted"
              : "Unavailable"
        },
        {
          label: "Capacity",
          value: this.instrument_instance.capacity
        },
        {
          label: "Daily Capacity",
          value: this.instrument_instance.daily_capacity
        },
        {
          label: "Runtime",
          value: this.instrument_instance.runtime
            ? `${this.instrument_instance.runtime} ${this.instrument_instance.runtime_display}`
            : "Unset"
        },
        {
          label: "Identifier",
          value: this.instrument_instance.identifier
        },
        {
          label: "Name",
          value: this.instrument_instance.name
        },
        {
          label: "Location",
          value: this.instrument_instance.location
        },
        {
          label: "Equipment Number",
          value: this.instrument_instance.equipment_number
        },
        {
          label: "Model Number",
          value: this.instrument_instance.model_number
        },
        {
          label: "Serial Number",
          value: this.instrument_instance.serial_number
        },
        {
          label: "Multi Result",
          value: this.instrument_instance.multi_result
            ? "Supported"
            : "Unavailable"
        },
        {
          label: "Priority",
          value: this.instrument_instance.primary
            ? "Primary"
            : this.instrument_instance.backup
            ? "Backup"
            : "Default"
        },
        {
          label: "Description",
          value: this.instrument_instance.description
        }
      ];
    }
  }
};
</script>
